<template>
  <ol>
    <li v-for="question in data.questions" v-html="question" />
  </ol>
</template>

<script>
  export default {
    name: 'ContentModuleDiscuss',
    props: ['data']
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  ol {
    margin:0; padding-left:2rem;
  }

  li + li {
    margin-top: 2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/discuss.vue